import React, { Component } from "react";
import * as PropTypes from "prop-types";
import FormDomanda from "./FormDomanda";
import AllegatiScaricabiliForm from "./AllegatiScaricabiliForm";
import Card from "@mui/material/Card";
import "./Domanda.css";
import CardContent from "@mui/material/CardContent";
import { ButtonGroup, CardMedia, Button } from "@mui/material";
import mainLogo from "./image/logoErasmus-senza sfondo.png";
import ueDisclaimer from "./image/UE_disclaimer.PNG";
import { configData } from "./configData/configData";
import { useParams } from "react-router-dom";
import { CircularProgress, Backdrop } from "@mui/material";
import fileImportato from "./resources/DICHIARAZIONE_SOSTITUTIVA_DELL'ATTO_DI_NOTORIETA.pdf"; // Importa il PDF
import axios from "axios";
axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");

const CustomConsensoDescription = () => (
  <div className="checkbox-description">
    <a
      href="https://www.euroformrfs.it/wp-content/uploads/2019/06/Informativa-Mobilit%C3%A0-Euroform.pdf"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: "none",
        fontWeight: "semibold",
        fontSize: "0.9rem",
      }}
    >
      Leggi l'informativa completa
    </a>
  </div>
);

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

FormDomanda.propTypes = { uiSchema: PropTypes.any };

class Domanda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schema: {},
      uiSchema: {},
      formData: {},
      prepopulatedData: {},
      currentPage: 1,
      pages: 1,
      cssCustom: "",
      errors: 0,
      allegati: [],
      loading: true,
    };
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

      axios
        .get(`${configData.API_BASE}/api/forms/${this.props.params.formId}`)
        .then((res) => {
          console.log(res.data);
          let jsonSchema = {};
          let uiSchema = {};

          const cleanedJsonSchema = res.data.jsonschema.replace(/\\/g, "\\\\");
          const cleanedUiSchema = res.data.uischema.replace(/\\/g, "\\\\");

          try {
            jsonSchema = JSON.parse(cleanedJsonSchema);
          } catch (error) {
            console.error("Error parsing jsonSchema", error);
          }

          try {
            uiSchema = JSON.parse(cleanedUiSchema);
            console.log("uiSchema caricato:", uiSchema);

            if (!uiSchema.consensoPresaVisione) {
              uiSchema.consensoPresaVisione = {};
            }

            /* uiSchema.consensoPresaVisione.consensoPresaVisioneAccettata = {
                      "ui:widget": "checkbox",
                      "ui:title": "Presa Visione", 
                      "ui:description": (
                        <div className="checkbox-description">
                          <p>
                            <a href="https://www.euroformrfs.it/wp-content/uploads/2019/06/Informativa-Mobilit%C3%A0-Euroform.pdf" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none'}} >
                              Leggi l'informativa completa
                            </a>
                          </p>
                        </div>
                      )
                    }; */

            uiSchema.consensoPresaVisione.consensoPresaVisioneAccettata = {
              "ui:widget": "checkbox",
              "ui:title": "Presa Visione",
              "ui:description": <CustomConsensoDescription />,
            };
          } catch (error) {
            console.error("Error parsing uiSchema", error);
          }

          // ✅ Set default false per tutti i boolean di trattamentoDatiPersonali
          if (jsonSchema.properties?.trattamentoDatiPersonali?.properties) {
            Object.entries(
              jsonSchema.properties.trattamentoDatiPersonali.properties
            ).forEach(([key, field]) => {
              if (field.type === "boolean") {
                field.default = false;
                console.log(
                  `Set default=false per trattamentoDatiPersonali.${key}`
                );
              }
            });
          }

          // ✅ Set default false e title custom per consensoPresaVisioneAccettata
          const consensoObj = jsonSchema.properties?.consensoPresaVisione;
          const checkbox =
            consensoObj?.properties?.consensoPresaVisioneAccettata;

          if (checkbox) {
            checkbox.default = false;

            // Modifica del title per consensoPresaVisioneAccettata: lo rendiamo una stringa
            // checkbox.title = "Presa Visione, Dichiaro di aver preso visione dell’informativa relativa al trattamento denominato: 'Progetti di mobilità transnazionale, tirocini formativi, formazione sul campo (WBL) e inserimento lavorativo'. Per leggere l'informativa completa, visitare: https://www.euroformrfs.it/it/privacy-it/";

            console.log(
              "Default impostato a false per consensoPresaVisioneAccettata"
            );
          }

          // ✅ Data attuale
          const dateNow = new Date().toISOString().slice(0, 10);
          if (jsonSchema.properties?.dataAttuale !== undefined) {
            jsonSchema.properties.dataAttuale.default = dateNow;
          }

          // ✅ CSS personalizzato per visibilità pagine
          let css = "";
          for (let i = 1; i <= res.data.pages; i++) {
            if (i !== this.state.currentPage) {
              css += `.f${i} { display: none; }\n.MuiGrid-item:has(.f${i}) { display: none; }\n`;
            }
          }
          if (this.state.currentPage !== res.data.pages) {
            css += `.submitButton { visibility: hidden; }`;
          }

          // ✅ Stato aggiornato
          this.setState({
            schema: jsonSchema,
            uiSchema: uiSchema,
            pages: res.data.pages,
            cssCustom: css,
          });

          // ✅ Prepopola dati
          if (this.props.params.formId == 2) {
            this.getPrepopulatedData(this.props.params.formId);
          }

          // ✅ Fetch allegati
          axios
            .get(
              `${configData.API_BASE}/api/formsAttach/${this.props.params.formId}`
            )
            .then((response) => {
              const allegatiTemp = [...this.state.allegati, ...response.data];
              console.log("Allegati ricevuti dal BE:", response.data);
              this.setState({ allegati: allegatiTemp, loading: false });
            })
            .catch((error) => {
              console.error("Errore nel recupero degli allegati", error);
            });
        })
        .catch((error) => {
          console.error("Errore nella richiesta API", error);
          this.setState({ loading: false });
        });
    } else {
      axios.defaults.headers.common["Authorization"] = null;
    }
  }

  // Aggiungi il metodo per recuperare i dati pre-popolati
  getPrepopulatedData = (formId) => {
    const userId = localStorage.getItem("id");
    const token = localStorage.getItem("token");
    if (!token) {
      console.error(
        "Token non trovato, impossibile recuperare i dati pre-popolati"
      );
      return;
    }

    // Esegui la richiesta per recuperare i dati pre-popolati
    axios
      .get(
        `${configData.API_BASE}/api/forms/submit/prepopulate/${formId}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          this.setState({
            prepopulatedData: response.data,
            formData: { ...this.state.formData, ...response.data }, // Pre-popolazione dei dati nel form
          });
        }
      })
      .catch((error) => {
        console.error("Errore nel recupero dei dati pre-popolati", error);
      });
  };

  // Metodo per navigare tra le pagine
  previousPage = () => {
    if (this.state.currentPage > 1) {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage - 1,
      }));
    }
  };

  nextPage = () => {
    if (this.state.currentPage < this.state.pages) {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage + 1,
      }));
    }
  };

  handleCallback = (newFormData) => {
    this.setState({ formData: newFormData });
  };

  render() {
    return (
      <Card
        style={{
          position: "absolute",
          left: "50%",
          transform: "translate(-50%)",
          boxShadow: "1px 3px 5px grey",
          borderRadius: "6px",
          padding: "1em",
        }}
      >
        <CardMedia component="img" image={mainLogo} alt="logo" />
        <CardContent>
          <style id="cssPagine">{this.state.cssCustom}</style>
          <ButtonGroup>
            <Button
              variant="contained"
              className="backButton"
              style={{
                display: this.state.currentPage === 1 ? "none" : "block",
              }}
              onClick={() => {
                this.previousPage();
              }}
            >
              previous page
            </Button>
            <Button
              variant="contained"
              className="nextButton"
              style={{
                display:
                  this.state.currentPage === this.state.pages
                    ? "none"
                    : "block",
              }}
              onClick={() => {
                this.nextPage();
              }}
            >
              next page
            </Button>
          </ButtonGroup>
          {this.state.loading ? (
            <Backdrop
              sx={{
                color: "#ffffff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <FormDomanda
              setErrors={this.setErrors}
              schema={this.state.schema}
              uiSchema={this.state.uiSchema}
              formData={this.state.formData}
              formId={this.props.params.formId}
              aggiornaStato={this.handleCallback}
            />
          )}
          {/* validazione file */}
          <script>
            {document
              .querySelectorAll("input[type=file]")
              .forEach((element) => {
                element.addEventListener("change", function () {
                  const file = this.files[0];
                  if (!file) return;

                  if (file.size > 524288) {
                    // 512 KB
                    alert(
                      "Il file che stai cercando di caricare non deve superare la dimensione di 512 KB."
                    );
                    this.value = "";

                    return;
                  }

                  // ✅ Controlla se è il campo fototessera
                  if (this.id.includes("fototessera")) {
                    if (
                      !(file.type === "image/jpeg" || file.type === "image/png")
                    ) {
                      alert(
                        "La fototessera deve essere in formato .jpg o .png."
                      );
                      this.value = "";
                    }
                  } else {
                    if (!file.type.includes("pdf")) {
                      alert("Il formato del file caricato deve essere .pdf.");
                      this.value = "";
                    }
                  }
                });
              })}
          </script>
          {/* Bottone per scaricare il PDF - posizionato dopo l'ultima domanda del form */}
          {/*<a
            href={fileImportato}
            download="DICHIARAZIONE_SOSTITUTIVA_DELL'ATTO_DI_NOTORIETA.pdf"
          >
            <Button variant="contained" style={{ marginTop: "20px" }}>
              Scarica la Dichiarazione sostitutiva
            </Button>
          </a>
          <br></br> <br></br>*/}
          <div style={{ marginTop: "40px" }}>
            <h4 style={{ fontWeight: "550" }}>Format allegati disponibili</h4>
            <a
              href={fileImportato}
              download="DICHIARAZIONE_SOSTITUTIVA_DELL'ATTO_DI_NOTORIETA.pdf"
              style={{ marginTop: "10px", display: "inline-block" }}
            >
              Dichiarazione sostitutiva
            </a>
            {this.props.params.formId == 3 && (
              <div>
                <a
                  href="https://www.euroformrfs.it/it/gulliver-2025/"
                  target="_blank"
                >
                  Domanda di iscrizione e informativa privacy
                </a>
                <br></br>
              </div>
            )}
            {this.state.currentPage === 1 && (
              <div style={{ marginTop: "30px" }}>
                <h4>Dichiaro</h4>
                <ul>
                  <li>
                    Di aver preso visione del bando e accettarne il contenuto
                  </li>
                  <li>
                    Di essere in possesso dei requisiti formali richiesti dal
                    Bando per l'ammissione alla selezione
                  </li>
                  <li>
                    Di non aver riportato condanne penali e di non avere
                    precedenti penali pendenti (in caso contrario, segnalare
                    quali)
                  </li>
                  <li>Che i dati riportati nel form sono veritieri</li>
                  {this.props.params.formId == 2 && (
                    <li>
                      Non usufruire di altri finanziamenti per soggiorni
                      all'estero, erogati su fondi dell'unione Europea
                      {/*this.props.params.formId == 3 && <div>regionali</div>*/}
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
          {/* I bottoni di navigazione o il tasto submit verranno dopo */}
          <ButtonGroup>
            <Button
              variant="contained"
              className="backButton"
              style={{
                display: this.state.currentPage === 1 ? "none" : "block",
              }}
              onClick={() => {
                this.previousPage();
              }}
            >
              previous page
            </Button>
            <Button
              variant="contained"
              className="nextButton"
              style={{
                display:
                  this.state.currentPage === this.state.pages
                    ? "none"
                    : "block",
              }}
              onClick={() => {
                this.nextPage();
              }}
            >
              next page
            </Button>
          </ButtonGroup>
        </CardContent>
      </Card>
    );
  }
}

export default withParams(Domanda);
